import { getIntegerAsString, getDateAsMoment } from '../../../data/booking/selectors/form';
import isEmpty from "lodash/isEmpty";

function getDefaultValues() {
    return {
        collectionDate: null,
        collectionPlace: {
            firstInput: null,
            secondInput: null
        },
        depositDate: null,
        depositPlace: {
            firstInput: null,
            secondInput: null
        },
        vehicleCount: 1,
        specification: {
            brand: null,
            model: null,
            registrationNumber: null
        }
    };
}

function getEditValues(state) {
    const { entities, editingItem } = state.booking;
    const item = entities.items[editingItem];

    let specification = item.specification
    if(isEmpty(item.specification) && !isEmpty(item.vehicleType)){
        specification = {
            registrationNumber: null,
            brand: null,
            model: item.vehicleType
        }
    }

    return {
        collectionDate: getDateAsMoment(item.collectionDate),
        collectionPlace: {
            firstInput: {
                ...item.collectionPlace,
                type: 'stop',
                id: item.collectionPlace.stop.id
            },
            secondInput: null
        },
        depositDate: getDateAsMoment(item.depositDate),
        depositPlace: {
            firstInput: {
                ...item.depositPlace,
                type: 'stop',
                id: item.depositPlace.stop.id
            },
            secondInput: null
        },
        vehicleCount: getIntegerAsString(item.vehicleCount),
        specification
    };
}

function equals(itemA, itemB){
    return getDateAsMoment(itemA.collectionDate).format() == getDateAsMoment(itemB.collectionDate).format()
        && getDateAsMoment(itemA.depositDate).format() == getDateAsMoment(itemB.depositDate).format()
        && itemA.vehicleCount == itemB.vehicleCount
        && itemA.collectionPlace && itemB.collectionPlace && itemA.collectionPlace.id == itemB.collectionPlace.id
        && itemA.depositPlace && itemB.depositPlace && itemA.depositPlace.id == itemB.depositPlace.id
        && JSON.stringify(itemA.specification) == JSON.stringify(itemB.specification)
}

export {
    getDefaultValues,
    getEditValues,
    equals
};
